import { createRoot } from "react-dom/client";
import CookieConsestBox from "../common/components/cookieConsestBox.js/cookieConsestBox";
import React from "react";
import { clearAllAuthData } from "../utils/authHelper.js";

const { default: axios } = require("axios");

const IS_PRODUCTION = false;
const IS_STAGING = false;

export const CDNServer =
  process.env.CDN_SERVER_URL ||
  (IS_PRODUCTION
    ? "https://cdn1.zaboon.app"
    : IS_STAGING
      ? //"https://d3olyamgpvd3ad.cloudfront.net" // old account stage
        "https://d12yu2t1irx2py.cloudfront.net" // new account stage
      : "https://d12yu2t1irx2py.cloudfront.net");

export const TCserver =
  process.env.TC_SERVER_URL ||
  (IS_PRODUCTION
    ? "https://serv.zaboon.app"
    : IS_STAGING
      ? "https://st.serv.zaboon.app"
      : "http://localhost:3000");

export const TRserver = process.env.TC_SERVER_URL || TCserver;

export const TLServer =
  process.env.ZN_PANEL_SERVER_URL ||
  (IS_PRODUCTION
    ? "https://dashboard.zaboon.app"
    : IS_STAGING
      ? "https://st.dashboard.zaboon.app"
      : "http://localhost:8000");

export const cookieDomain =
  process.env.NODE_ENV ||
  (IS_PRODUCTION || IS_STAGING ? ".zaboon.app" : "localhost");

export const CUSTOMER_PAGE_SECRET_TOKEN =
  process.env.CUSTOMER_PAGE_SECRET_TOKEN ||
  "Fds43FaF45H5jg95H9jG943Fa94S403Gs8jbRfFS4gaeru65Jfg4FSa9fj4AFf9jf3jf";
export const BACKDOOR_LOGIN_PAGE_SECRET_TOKEN =
  process.env.BACKDOOR_LOGIN_PAGE_SECRET_TOKEN ||
  "oi2w4dfs84GF439o0gfDS94tRGTjloqa43aiopJjkmNCo9eEWQRjbcv3WRE345238ff";
export const VERIFICATION_EMAIL_SECRET_TOKEN =
  process.env.VERIFICATION_EMAIL_SECRET_TOKEN ||
  "r8GhT29Wpq3ZxYuKM71nVLEgoF59DcXkqWaJF3mPbOvRI45tcsX2B0udgHl9AeTYd32";

//  function secureConnect(token, url = server) {
//   return axios.create({
//     baseURL: url,

//     headers: {
//       Authorization: "Bearer " + token,
//       // "Content-Type": "application/json",
//       // "Content-Type": "multipart/form-data",
//     },
//   });
// }

const axiosInstance = axios.create({
  baseURL: TCserver,
  // headers: {
  //   // 'User-Agent': 'TajerCustomer/0.1',
  //   "Content-Type":'multipart/form-data'    //   "Content-Type": "application/json",
  // },
});
export function connect(withCredentials = false, url = TCserver) {
  try {
    // const headers = {
    //   'X-Manager-Token': token?.token || '',
    // };
    axiosInstance.defaults.baseURL = url;
    axiosInstance.defaults.withCredentials = withCredentials;
    // Object.assign(axiosInstance.defaults.headers.common, headers);
    return axiosInstance;
  } catch (err) {
    console.log(err, "error with axiossss");
  }
}

axiosInstance.interceptors.request.use(
  (config) => {
    config.metadata = { startTime: new Date() };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const SESSION_REDIRECTING_KEY = "__zn_401_redirecting";

axiosInstance.interceptors.response.use(
  function (response) {
    response.config.metadata.endTime = new Date();
    response.duration =
      response.config.metadata.endTime - response.config.metadata.startTime;
    return response;
  },
  function (error) {
    console.log("error with request");
    const status = error?.response?.status;
    if (status == 511) {
      const r = createRoot(
        document.getElementById(
          "ThisIsToInjectCookieBoxIdWhichExistInAppWrapperTC",
        ),
      );
      r.render(
        <React.StrictMode>
          <CookieConsestBox
            preventedThirdPartyCookie={true}
            language={localStorage?.getItem("gatsby-i18next-language")}
          />
        </React.StrictMode>,
      );
    } else if (status == 401) {
      const currentPath = typeof window !== "undefined" ? window.location.pathname : "";
      const isOnLoginPage = currentPath.includes("/auth/");
      const isOnPublicPage = currentPath.includes("/pub/");
      if (!isOnLoginPage && !isOnPublicPage) {
        const alreadyRedirecting = sessionStorage?.getItem(SESSION_REDIRECTING_KEY) === "1";
        if (!alreadyRedirecting) {
          sessionStorage?.setItem(SESSION_REDIRECTING_KEY, "1");
          clearAllAuthData();
          sessionStorage?.setItem(SESSION_REDIRECTING_KEY, "1");
          setTimeout(() => {
            sessionStorage?.removeItem(SESSION_REDIRECTING_KEY);
            window?.location.replace("/auth/login");
          }, 100);
        }
      }
    }
    const retryCount = error.config.headers["Retry-Count-429"] || 0;
    if (status === 429 && retryCount < 12) {
      console.log("retrying");
      const config = error.config;
      config.headers["Retry-Count-429"] = Number(retryCount) + 1;
      console.log(config.headers["Retry-Count-429"]);
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(axiosInstance(config));
        }, 90000);
      });
    } else {
      return Promise.reject(error);
    }
  },
);
